import { petriCombos } from '../config/petri-combinations';

const activePetri = ( state = petriCombos[0], action ) => {
    switch( action.type ) {
        case "SET_ACTIVE_PETRI":
            return action.petriCombo;
        default:
            return state;
    }
};

export default activePetri;


// WEBPACK FOOTER //
// ./src/reducers/active-petri-dish.js